const demo_app = {
    notification: 'İpucu: Oturum açma deneyimini test etmek için önce bir hesap oluşturun.',
};
export default demo_app;
